// extracted by mini-css-extract-plugin
export var width100 = "L_v d_v";
export var design3Pos = "L_wB d_Z";